/* eslint-disable no-multi-spaces */
import VueRouter     from 'vue-router'
import mypage        from './components/mypage.vue'
import signIn        from './components/sign-in.vue'
import user          from './components/user.vue'
import account       from './components/account.vue'
import pageCreator   from './components/page-creator.vue'
import pageContainer from './components/page-container.vue'
import page          from './components/page.vue'
import pageMembers   from './components/page-members.vue'
import pageSales     from './components/page-sales.vue'
import order         from './components/order.vue'
import receipt       from './components/view-model/receipt.vue'
import pageEditor    from './components/page-editor.vue'
import imageCapture  from './components/image-capture.js'
import item          from './components/item.vue'
import itemEditor    from './components/item-editor.vue'
import cModal        from './components/view/c-modal.vue'
import lp            from '@/components/view/lp'
import cachalog404   from './components/404.js'
import dashboard     from '@/components/dashboard'
/* eslint-enable */

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      name: 'mypage',
      path: '/',
      component: mypage,
      props: {routeTitle: 'カチャログ'},
      children: [
        {
          name: 'receipt',
          path: '/users/:uid/receipts/:receiptId',
          components: {
            'page-sub': receipt
          },
          props: {
            'page-sub': route => ({
              uid: route.params.uid,
              receiptId: route.params.receiptId,
              routeTitle: 'レシート - :pageTitle'
            })
          }
        }
      ]
    },
    {
      name: 'sign-in',
      path: '/sign-in',
      component: signIn,
      props: {routeTitle: 'カチャログにサインイン'}
    },
    {
      name: 'user',
      path: '/users/:uid',
      component: user,
      props: route => ({
        uid: route.params.uid,
        routeTitle: ':nicknameのプロフィール'
      })
    },
    {
      name: 'account',
      path: '/account',
      component: account,
      props: {routeTitle: 'プロフィール編集'}
    },
    {
      name: 'faq',
      path: '/faq',
      component: lp,
      props: {routeTitle: 'よくある質問'}
    },
    {
      name: 'dashboard',
      path: '/dashboard',
      component: dashboard,
      props: {routeTitle: 'ダッシュボード'}
    },
    {
      name: 'page-creator',
      path: '/pages/new',
      component: pageCreator,
      props: {routeTitle: 'ショップ登録'}
    },
    {
      path: '/:pageId',
      component: pageContainer,
      props: true,
      children: [
        {
          name: 'page',
          path: '/:pageId',
          components: {'page-main': page},
          props: {
            'page-main': route => ({
              pageId: route.params.pageId,
              routeTitle: ':pageTitle'
            })
          }
        },
        {
          name: 'page-members',
          path: 'members',
          components: {'page-main': pageMembers},
          props: {
            'page-main': {
              routeTitle: 'メンバー管理 - :pageTitle'
            }
          }
        },
        {
          name: 'page-sales-index',
          path: 'sales',
          components: {'page-main': pageSales},
          props: {
            'page-main': route => ({
              pageId: route.params.pageId,
              routeTitle: '販売履歴 - :pageTitle'
            })
          }
        },
        {
          name: 'page-sales',
          path: 'sales/:saleId',
          components: {
            'page-main': pageSales,
            'page-sub': order
          },
          props: {
            'page-sub': route => ({
              pageId: route.params.pageId,
              saleId: route.params.saleId,
              routeTitle: '販売明細 - :pageTitle'
            }),
            'page-main': true
          }
        },
        {
          name: 'page-editor',
          path: 'edit',
          components: {
            'page-main': page,
            'page-sub': pageEditor,
            'image-capture': imageCapture
          },
          props: {
            'page-sub': route => ({
              pageId: route.params.pageId,
              routeTitle: 'ショップ編集'
            })
          }
        },
        {
          name: 'item',
          path: 'items/:itemId',
          components: {
            'page-main': page,
            'page-sub': item
          },
          props: {
            'page-sub': route => ({
              pageId: route.params.pageId,
              itemId: route.params.itemId,
              routeTitle: ':itemName - :pageTitle'
            })
          }
        },
        {
          name: 'item-editor',
          path: 'items/:itemId/edit',
          components: {
            'page-main': page,
            'page-sub': itemEditor,
            'image-capture': imageCapture
          },
          props: {
            'page-sub': route => ({
              pageId: route.params.pageId,
              itemId: route.params.itemId,
              routeTitle: '商品編集 - :pageTitle'
            })
          }
        },
        {
          name: 'qrcode-reader',
          path: 'qrcode-reader',
          components: {
            'page-main': page,
            'qrcode-reader': cModal
          }
        },
        {
          name: 'qrcode-order',
          path: 'qr-order',
          components: {
            'page-main': page,
            'qrcode-order': cModal
          }
        },
        {
          name: 'qrcode-page',
          path: 'qr-url',
          components: {
            'page-main': page,
            'qrcode-page': cModal
          }
        },
        {
          name: 'order',
          path: '/orders/:wishlistId',
          components: {
            'page-main': page,
            'page-sub': order
          },
          props: {
            'page-sub': route => ({
              wishlistId: route.params.wishlistId,
              routeTitle: '注文内容 - :pageTitle'
            })
          }
        }
      ]
    },
    {
      path: '*',
      component: cachalog404,
      props: {routeTitle: '404 Not Found'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js